module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p3"
  }), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('b', [_vm._v("Elsewhere")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("“Mr. Ferraro?”")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("“Here.”")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("A tall, curly-headed, dark-haired man, about thirty, rose from among the Waiting Dead. Apex Employment Agency was busy that day. At least three dozen people occupied chairs in the reception area. Most had been sitting, slumped and hopeless, for hours. Gene Ferraro was lucky, having had only a forty-minute wait.")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("“Hi. Jerry Lesko.”")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("Gene took the kid’s hand — Lesko was no more than twenty-five, probably a good deal younger. “A pleasure.”")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("“Come on back.”")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("“Sure.”")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("Gene picked up his attaché case and followed Lesko through a maze of desks and partitioned offices until they came to a cluttered cubicle, which they entered. Lesko took a seat behind a gray steel desk and motioned for Gene to sit in the small hard-backed chair next to it.")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("“First we gotta get you to sign this,” Lesko said, placing in front of Gene a large yellow filing card densely inked with small lettering. “Read it and sign if you want to.”")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("Glancing over it, Gene recognized it as the usual agreement to fork over a certain percentage — in this case a healthy fifteen percent — of the signee’s yearly salary, payable immediately and in full should the signee accept any job offer resulting from the agency’s referral. Fine. You pay to work. Dandy.")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("Gene signed it, slid it across the desk to Lesko.")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("“Good. Now fill this out.”")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("“What is it?”")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("“Credit check.”")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("“Why?”")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("“Company policy. You may have to borrow to pay the fee. Fifteen percent of your salary, you know. Just put down your bank account, and list any major credit cards.”")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("“I don’t have a bank account, at least not a checking account. No credit cards either.”")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("“Oh. Did you ever have a student loan? Says here you have a degree . . . couple degrees, in fact.”")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("“Never did. Scholarships, fellowships, teaching assistantships, that sort of thing. My parents covered whatever shortfalls there were.”")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("“You’re lucky. Must be pretty smart. Well . . . have a savings account?”")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("“Put that down.”")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("“I’m afraid I don’t have the passbook with me, and I don’t remember the account number.”")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("“Well, just put down the name of the bank.”")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("“Sure.” Gene did so and handed the form back to Lesko.")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("“You live with your parents? Hard to get along without — ”")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("“Yeah, temporarily, until I find work.”")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("“Good idea. Can’t hurt.”")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("“Yeah.”")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("Lesko passed his eyes over Gene’s resumé. Gene got the impression it was the first time he’d seen it.")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("“You have a master’s degree. What in?”")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("“Says right there. Philosophy.”")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("Lesko found it. “Oh, yeah. Really? I have a cousin who majored in psychology. She had a hard time finding — ”")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("“Philosophy.”")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("“Huh?”")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("“Philosophy, not psychology.”")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("“Oh. It’s different?”")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("“Very.”")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("“Uh-huh. Gee, you’ve had a lot of schooling.”")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("“Unfortunately, when you put it all together, it comes up short of a marketable skill.”")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("“That’s too bad. Economy’s in real bad shape too. It’s going to be hard to place you.”")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("“I know. In fact, I more or less just said that . . . unless I’m badly mistaken.”")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("Lesko frowned and averted his eyes. “What . . . uh, what were you studying for? To be a . . . philosopher?”")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("Sighing, Gene answered, “I wanted to teach. Teach in a university — do you understand? I was after an assistant professorship, tenure-track, and I was just at the point of writing my dissertation when it dawned on me that the job market had completely dried up. Even with the Ph.D., getting a job was unlikely. I quit and went to law school.”")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("“Yeah, I see. You quit that too.”")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("“Right. The lawyer’s path is rocky with ethical dilemmas every foot of the way. Most lawyers simply step over them. I stumbled on the first few, and decided it wasn’t for me.”")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("“Yeah?” Lesko said emptily.")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("“Also, competition in that field is stiff too. Every field. Post-war baby boom, the demographic bulge.” Gene shrugged. “You know?”")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("“Uh-huh, uh-huh. Well . . . what did you do after that?”")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("“Worked in a car wash, then bartending, then . . . for years, a series of odd jobs. In my spare time, I wrote.”")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("“What did you write?”")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("“Poetry, fiction. None of it publishable, I’m afraid.”")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("“Oh, you’re a writer? Well, we may have something in that line.” He went through the card file again. “Ever do any technical writing?”")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("“No.”")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("“Oh. We always get listings for technical writers.”")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("“I had two semesters of mechanical engineering.”")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("Lesko’s eyes lit up. “Hey, right. We may have something for you.”")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("“I changed to liberal arts when — ” Gene blinked. “You do?”")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("“Yeah. Says here, ‘In-House Technical Writer.’ Now, what a technical writer does is — well, he sort of . . . um . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("“Right.”")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("“Takes technical stuff and . . . you know.”")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("“I have a fair idea of what the job entails.”")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("“Oh, good. Tell you what, why don’t you go back to reception and have a seat. Let me contact the employer and see if I can sell them on you.”")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("“Fine with me.”")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("“Can’t promise anything. I mean, your employment history . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("“I drifted a lot.”")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("“Yeah. It’s kind of hard. Look, go out and have a cigarette or something and we’ll see what we can do. Can’t hurt. Right?”")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("“Fine.”")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("Gene was surprised to see Lesko again in only ten minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("“Mr. Ferrari? Look, I — ”")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("“Ferraro.”")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("“Right. I talked to the personnel manager over at USX — that’s the employer — and he says they have over two hundred applicants for that job already. But he has a cancellation today, and I talked him into seeing you. Can’t hurt. Right?”")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("“Can’t hurt,” Gene said.")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("“Just give him this card. Okay?”")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("“Can’t hurt.”")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("“Huh?”")]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("When he emerged from the lobby of the office building into the wilting August sun. Gene saw that his blue VW bug was in process of being ticketed and towed away. He sprinted across the street, talked the cop out of following through with the tow, and settled for the twenty-five-dollar ticket. Then he got in, fired up the Bug and drove away. Thinking that he might as well spring for the two bucks or whatever it was for the underground facility at the USX building — couldn’t afford the risk of another whopping fine — he turned up Forbes Avenue, then hung a right on Grant Street, there to bump along the cobblestones, threading his way through the almost-rush-hour traffic. The USX building hove into view as he approached the intersection of Bigelow Boulevard. It was an immense, peculiar-looking edifice of reticulated surfaces and myriad small windows. It was the exact color of rust, this so because of the special steel of its exposed frame (expressive of its organic structure, don’t you know), a remarkable alloy designed specifically to accrete a protective layer of oxidation on its surface, but no deeper.")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("Gene saw USX parking and turned in, traversed a narrow roadway that skirted the edge of an expansive plaza, and plunged into the mouth of a tunnel that spiraled down into the bowels of the underground lot.")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("The first level was full, as was the second and the third. So was the forth. There, he chanced across an attendant removing barriers blocking a ramp descending to still lower depths. He leaned out of the window.")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("“Hey! How far down does it go?”")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("“Got me, I just started today. Go ahead down. Plenty of room.”")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("“Can’t hurt.”")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("Reaching the fifth level, he felt a wild hair at his fundamental aperture and decided, what the hell, let’s see how far down it does go.")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("Two more sub-sub-basements down. Gene was amazed. The place was vast, tomblike in its silence. Gene picked an arbitrary slot marked by parallel yellow lines and pulled in. With the motor off, the stillness fell like the lid of a sarcophagus.")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("Now I know. Gene thought, where to run when the balloon goes up, as the boys at the Pentagon are wont to say.")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("He locked the car and struck out into the dimness of the reinforced concrete cavern, looking for a way up, his footsteps echoing hollowly. He couldn’t find a sign. Coming to the mouth of the ramp, he looked up, saw it was a long way to walk — dangerous too — and decided there must be a stairwell, or better yet, an elevator around somewhere.")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("He searched in vain. He did find a featureless corridor which met another at a T. To his right the way was dark, so he turned left, turned again at an L, and found himself back in the concrete-walled silence of the garage again. Sighing, he retraced his steps, passed the intersection of the first corridor and continued on into the darkness. Feeling his way, he went about thirty paces until he bumped into a wall. The passageway turned to the right, still unlighted, and continued interminably.")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("“Absolutely ridiculous.”")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("Another turn, and there was light up ahead. Gene could see a stairwell.")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("“Now we are getting somewhere.”")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("Once into the light, coming from a strange fixture mounted on the wall at about eye level, he noticed that walls of the corridor were now of masonry, meticulously executed, with dark stones set in intricate patterns. The stone itself was dark gray in color, spangled with tiny glowing flecks of red, blue, and green. Then he noticed the light fixture. It looked more or less like a torch, a long wooden handle mounted into a bracket affixed to the stone, but at the top of the handle there was a glowing bulb shaped like a faceted jewel. The light it emitted was bright and of a faintly bluish cast.")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("“USX’s medieval period, I guess.”")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("He mounted the stairwell, which turned to the left, then to the right, and came out into another passageway identical to the one below, complete with the odd light fixture and another stairwell set into the opposite wall.")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("Four stories up he began to wonder what the hell was going on. This could not be . . . no, categorically impossible . . . could not be the USX building. Where the hell was he?")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("As he thought it over, sounds came from his right. He listened. A low rumbling, then . . . a scream? He walked on down the passageway toward the noise, coming to the pool of light cast by the next jewel-torch. Farther down, another corridor intersected. The sounds came from the branch to the right. He approached the corner.")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("What he heard next made him drop his attaché case. It was the full-throated yowl of some hell-spawned behemoth, the thunder of its rage shivering the stones around him. He backed away. He heard another scream. From the adjoining corridor came the sound of running feet, advancing toward him.")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("Bursting around the corner came a man in full flight. He came right at Gene, saw him, yelped, danced around him and ran on into the shadows.")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("“Hey!” Gene yelled after him. “Hey, buddy!”")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("He was gone. Gene picked up his briefcase and trotted after him for a few steps, then stopped. He scratched his head. The man had been dressed strangely.")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("The horrific noise sounded again, much nearer. Gene took a few more paces in pursuit but stopped again, unsure of what to do. He looked back toward the intersecting passageway.")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("What came running around the corner this time froze him solid to the floor.")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("It was large, maybe seven, eight feet, walked on two legs, and was covered head to foot with silky white fur. Oh, and the head. The head was smallish, but the mouth was not, agleam with razor-edged teeth and curved three-inch fangs. Bone-white claws tipped its fingers. Its shoulders were almost as broad as the beast was tall, and from them hung long sinewy arms. But with all that bulk, it was fast. And it was coming toward him.")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("Somewhere within Gene’s mind, a part that had not as yet turned the consistency of Cream of Wheat, he was thinking, Movie, they’re filming a movie. Oh, yes, that’s what it is.")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("As the beast neared, the glow from the jewel-torch fired its eyes, luminescent yellow agates. An alien intelligence burned within them, fierce, cruel, and inhuman."), _c('span', {
    staticClass: "Apple-converted-space"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("The sound of the hell-beast shook the passageway.")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("But the white-furred thing ran right past him — and as it went by, it spoke.")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("It said, “Run, you fool!”")]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1378464b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section9.vue
// module id = 90
// module chunks = 0